import { ordemServicoApi } from '../clients/AxiosClients'

/**
 * Retorna todoas as Ordens de Servicos cadastradas no banco de dados
 */
const recuperarNumeroDeFustesDoPlantio = async (idEstratoFlorestal) => {
	return ordemServicoApi.get(
		`/PlanejamentoDeOrdemDeServicoSingleTrees/recuperar-numero-de-fustes-do-plantio?estratoFlorestalId=${idEstratoFlorestal}`,
	)
}

/**
 * Faz o planejamento de ordem de servico tradicional
 */
const ordemDeServicoSingleTreesPlanejar = async (dto) => {
	return await ordemServicoApi.post(
		`/PlanejamentoDeOrdemDeServicoSingleTrees/ordem-de-servico-single-trees-planejar`,
		dto,
	)
}

export { recuperarNumeroDeFustesDoPlantio, ordemDeServicoSingleTreesPlanejar }
